module.exports = "/dashboard/manage/feedback/index-1fa9a2.html";